export const calculateTotalChannelROI = (
  channelName: string,
  channelTotals: {
    [key: string]: { totalRevenue?: number; totalSpend?: number };
  }
) => {
  const revenue = channelTotals[channelName]?.totalRevenue ?? 0;
  const spend = channelTotals[channelName]?.totalSpend ?? 0;

  if (spend === 0) return null;
  return (100 * (revenue - spend)) / spend;
};
